import { setStoragePort } from "@repo/shared/storage";

import { safeGetItem, safeRemoveItem, safeSetItem } from "./safeStorage";

/**
 * The web adapter for `@repo/shared/storage`. Thin, because localStorage
 * already matches the port.
 *
 * Keys stay bare: earlier builds wrote them unprefixed, and namespacing now
 * would orphan every existing user's cache.
 */
export const registerWebStoragePort = (): void =>
  setStoragePort({
    get: safeGetItem,
    set: safeSetItem,
    remove: safeRemoveItem,
    keys: () => {
      try {
        return Object.keys(localStorage);
      } catch {
        // Storage disabled: the SecurityError safeStorage guards against.
        return [];
      }
    },
  });
